module.exports = __webpack_public_path__ + "static/img/case_detail_16_1_h5.29bba7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_16_1_h5.png
// module id = 1tQL
// module chunks = 34